module.exports = __webpack_public_path__ + "static/soul_monger-1ca395c82048e9a93d44ef2c0e56d502.png";